import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { SubscriptionSearchCohabitationCrumbs } from 'subscription/constants/breadcrumb';
import SearchCohabitation from 'shell/components/shared/search-cohabitation';
import ActionsList from './actions';

const CohabitationPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SubscriptionSearchCohabitationCrumbs} />
      <SearchCohabitation action={ActionsList} />
    </Fragment>
  );
};

CohabitationPage.displayName = 'Cohabitation page component';

export default CohabitationPage;
